module.exports = __webpack_public_path__ + "static/media/logo_wo.8db9a3e0.png";